// extracted by mini-css-extract-plugin
export default {"container":"StartView_container__KEszA","menu":"StartView_menu__AcitB","item":"StartView_item__ACS7G"};